module.exports = __webpack_public_path__ + "static/img/tutorial-normal-competitiveness-2.bb5edc0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tutorial-normal-competitiveness-2.jpg
// module id = klOU
// module chunks = 3